import { numberFormat as formatNumberBase } from '@fiverr-private/localization';

const DEPRECATED_formatNumber = (number) => number.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');

export const formatNumber = (number) =>
    formatNumberBase({
        value: number,
        options: {
            maximumFractionDigits: 0, // NOTE: this package shows large numbers so we're cutting all fraction digits by default
            fallbackValue: DEPRECATED_formatNumber(number),
        },
    });
